<template>
    <b-modal
        v-model="modal"
        title="Detail"
        hide-footer
        centered
        @show="setData"
        @hidden="resetData"
    >
        <template v-if="detailData">
            <b-row class="mb-2">
                <b-col><b>AWS Account ID:</b></b-col>
                <b-col>{{ detailData.awsAccountId }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>AWS Account Name:</b></b-col>
                <b-col>{{ detailData.awsAccountName }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>Access Key ID:</b></b-col>
                <b-col>{{ detailData.accessKeyId }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>Secret Access Key:</b></b-col>
                <b-col>{{ detailData.secretAccessKey }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>created at</b></b-col>
                <b-col>{{ detailData.createdAt }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><b>isShared</b></b-col>
                <b-col
                    ><b-badge
                        :variant="detailData.isShared ? 'info' : 'secondary'"
                        >{{ detailData.isShared }}</b-badge
                    ></b-col
                >
            </b-row>
        </template>
    </b-modal>
</template>

<script>
import { getPayerAwsAccountDetail } from '@/services/aws.service';

export default {
    name: 'DetailPayerModal',
    props: {
        awsAccountUuid: {
            required: true,
        },
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    data() {
        return {
            detailData: null,
        };
    },
    methods: {
        setData() {
            getPayerAwsAccountDetail(this.awsAccountUuid).then(({ data }) => {
                this.detailData = data;
            });
        },
        resetData() {
            this.detailData = null;
        },
    },
};
</script>

<style scoped></style>
